import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import {createSelector} from 'reselect';
import AuthService from "../../admin/components/util/AuthService";
import {Link} from "react-router-dom";
import ApiService from "../../admin/components/util/ApiService";

const ProfileDropdownCompany = () => {
    const [selectedCompany, setSelectedCompany] = useState(null);
    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (user) => user.user
    );
    // Inside your component
    const user = AuthService.getUserData();
    const [search, setSearch] = useState("");

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };


    const filteredCompanies = user?.companies?.filter(company =>
        company.name.toLowerCase().includes(search.toLowerCase())
    ) || [];


    const handleCompanySelect = async (company) => {
        try {
            setSelectedCompany(company);

            // Atualiza no estado local
            const updatedCompanies = user?.companies?.map(c => ({
                ...c,
                selected: c.user_id === company.user_id ? 1 : 0
            }));

            // Atualiza no localStorage
            AuthService.setUserValue("companies", updatedCompanies);
            // Envia a atualização para o backend
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}documents/update-selected`,
                {company_id: company.user_id},
                true
            );

            if (response.code === 200) {

                setTimeout(() => {
                    window.location.reload();
                }, 200); // espera para garantir que tudo foi salvo

            } else {
                console.error("Erro ao atualizar empresa no backend:", response.data?.message || "Erro desconhecido");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const domain = window.location.hostname;

    useEffect(() => {
        // Recupera os logos do localStorage


        const user = AuthService.getUserData();


        // const cachedImages = JSON.parse(localStorage.getItem(`custom_images_${domain}`)) || {};
        // setLogos({
        //     logo: cachedImages.logo || "/default-logo.png",
        //     smallLogo: cachedImages.smallLogo || "/default-small-logo.png",
        // });

        if (user && user?.companies) {
            setSelectedCompany(user?.companies?.find(c => c.selected) || user.companies[0]);
        }
    }, []);


    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown}
                      className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                           <img
                               className="rounded-circle header-profile-user object-fit-cover"
                               src={selectedCompany?.profile_image || process.env.REACT_APP_URL_STORAGE + 'src/hospital_icone.png'}
                               id="profile-user-top"
                               alt="Perfil Empresa"
                               style={{width: '35px', height: '35px'}} // ajuste o tamanho desejado
                           />
                        <span className="text-start ms-xl-2">
                            <span
                                className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{selectedCompany?.name}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Empresas </h6>

                    {user.companies?.length > 0 && (
                        <>
                            {/* Campo de Pesquisa */}

                            <input
                                className="form-control"
                                placeholder="Buscar empresa..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />

                            <ul style={{listStyle: "none", padding: 0, margin: 0}}>
                                <li>
                                    <div style={{maxHeight: "200px", overflowY: "auto"}}>
                                        {filteredCompanies?.length > 0 && (


                                            filteredCompanies?.map((company, index) => (
                                                <button
                                                    key={`${company.user_id}-${index}`}
                                                    className="dropdown-item d-flex align-items-center"
                                                    onClick={() => handleCompanySelect(company)}
                                                >
                                                    <img
                                                        src={company?.profile_image || process.env.REACT_APP_URL_STORAGE + 'src/hospital_icone.png'}
                                                        alt="Ícone" width={20} height={20} className="me-2"/>
                                                    {company?.name}
                                                </button>
                                            ))
                                        )}
                                    </div>
                                </li>
                            </ul>
                        </>
                    )}
                    {
                        filteredCompanies?.length === 0 && (
                            <div className="alert alert-primary small m-2" role="alert">Nenhuma empresa
                                encontrada</div>
                        )}

                    {user?.users_type_id === 1 && (
                        <DropdownItem href="/admin/accreditation-users"><i
                            className="mdi mdi-page-next text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Credenciamentos</span></DropdownItem>
                    )}


                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
        ;
};

export default ProfileDropdownCompany;